import "../styles/physio.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useCurrentLang } from "../hooks/useCurrentLang";
import { privacyPolicyContent } from "../data/privacyPolicyContent";

export default function PrivacyPolicyPage() {
  const currentLang = useCurrentLang();
  const t = privacyPolicyContent[currentLang];

  return (
    <>
      <Header />

      <div className="page--physio">
        <div className="physio-layout">
          <main className="physio-main">
            {/* Hero / Intro card */}
            <section className="physio-section" id="privacy-hero">
              <div className="glass-card">
                <span className="physio-eyebrow">Privacy & Testing</span>
                <h1>{t.heroTitle}</h1>

                <div className="physio-divider" />

                <p className="section-lead">{t.heroLead}</p>

                <p>
                  <strong>{t.lastUpdatedLabel}</strong> {t.lastUpdatedValue}
                </p>
              </div>
            </section>

            {/* Individual sections as glass cards */}
            {t.sections.map((section) => (
              <section
                key={section.id}
                className="physio-section"
                id={`privacy-${section.id}`}
              >
                <div className="glass-card" style={{padding: "25px"}}>
                  <span className="physio-eyebrow">{section.eyebrow}</span>
                  <h2>{section.title}</h2>
                  <div className="physio-divider" />

                  <div className="physio-text">
                    {section.text
                      .trim()
                      .split("\n\n")
                      .map((paragraph, index) => (
                        <p key={index}>{paragraph.trim()}</p>
                      ))}
                  </div>
                </div>
              </section>
            ))}
          </main>
        </div>
      </div>

      <Footer />
    </>
  );
}